import { SxProps } from '@mui/material';
import { black, grey4 } from 'app/components/ThemeProvider/colors';

export const paperProps: SxProps = { borderRadius: '8px', width: '517px', maxHeight: 'none' };

export const dialogTitle: SxProps = {
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '32px 32px',
  paddingBottom: '0px',
};

export const closeBtn: SxProps = {
  padding: '10px',
  minWidth: '36px',
  height: '36px',
  width: '36px',
  borderRadius: '8px',
  alignItems: 'centre',

  '& .MuiSvgIcon-root': {
    width: '16px',
    height: '16px',
  },
};

export const dialogContent: SxProps = {
  padding: '40px 32px',
  paddingTop: '40px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '30px',
  alignItems: 'center',
};

export const code: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '32px',
  fontWeight: '400',
  color: black,
  padding: '6px 24px',
  background: grey4,
  width: '119px',
  borderRadius: '10px',
  display: 'flex',
  justifyContent: 'center',
};
